import AuthScreen from "./AuthScreen";

/**
 * Register — `/Register` route. Split-screen auth, Create account tab active.
 */
function Register() {
    return <AuthScreen defaultTab="register" />;
}

export default Register;
